// deps
import * as React from "react";

// interfaces
import { JuspayClientAuthTokenData, JuspaySdkFeatureAvailable } from "@payment-client/interfaces/Juspay";

export interface JuspayContextValue {
    isSdkAvailable: boolean;
    clientAuthTokenData?: JuspayClientAuthTokenData | Record<string, JuspayClientAuthTokenData>;
    featuresAvailability?: JuspaySdkFeatureAvailable;
    fetchingJuspaySdk?: boolean;
    fetchJuspayClientAuthToken?: () => Promise<
        JuspayClientAuthTokenData | Record<string, JuspayClientAuthTokenData> | void
    >;
}

const initialJuspayContextValue: JuspayContextValue = {
    isSdkAvailable: false,
    featuresAvailability: undefined,
    fetchingJuspaySdk: false,
    fetchJuspayClientAuthToken: async () => Promise.resolve(),
};

export const JuspayContext = React.createContext<JuspayContextValue>(initialJuspayContextValue);

if (__DEV__) {
    JuspayContext.displayName = "JuspayContext";
}
